class WalletsConfigs {
}
/**
 * @deprecated Pass `walletConnectConfigs` directly to the wallet provider factory
 * (e.g. `createEVMProvider({ walletConnectConfigs })`). This static config will be removed soon.
 */
WalletsConfigs.WalletConnectConfig = {
    projectId: '28168903b2d30c75e5f7f2d71902581b',
    name: 'Layerswap',
    description: 'Layerswap App',
    url: 'https://layerswap.io/app/',
    icons: ['https://www.layerswap.io/app/symbol.png']
};
/**
 * @deprecated Pass `tonConfigs` to `createTONProvider({ tonConfigs })`. This fallback will be removed.
 */
WalletsConfigs.TonClientConfig = {
    tonApiKey: '815b3d3036592d941bbcec5a4db824a588c1b2d210c3a4b6d188dcd4a15337d2',
    manifestUrl: `https://layerswap.io/app/tonconnect-manifest.json`
};
/**
 * @deprecated Pass `imtblPassportConfig` to `createImmutablePassportProvider({ imtblPassportConfig })`.
 */
WalletsConfigs.ImtblPassportConfig = {
    publishableKey: "",
    clientId: "",
    redirectUri: "",
    logoutRedirectUri: ""
};
class AppSettings extends WalletsConfigs {
}
AppSettings.ApiVersion = "mainnet";
AppSettings.ExplorerURl = `https://www.layerswap.io/explorer/`;
AppSettings.LayerswapApiUri = 'https://api.layerswap.io';
AppSettings.ResourseStorageUrl = 'https://prodlslayerswapbridgesa.blob.core.windows.net/';
AppSettings.TelegramLogConfigs = {
    feedback_token: '',
    feedback_chat_id: '',
    error_token: '',
    error_chat_id: ''
};
AppSettings.LayerswapApiKeys = {
    'mainnet': 'NDBxG+aon6WlbgIA2LfwmcbLU52qUL9qTnztTuTRPNSohf/VnxXpRaJlA5uLSQVqP8YGIiy/0mz+mMeZhLY4/Q',
    'testnet': 'Dz1jVir9WUD0gBWoGbOmS1oe5K4985SGptaZXjF4z9VVrvO5nC9q55h8TE/3CIESRxWdYVpPnz/H2BogL2eG+A'
};
export default AppSettings;
